import React from 'react';
import { Table } from '@chaser/components';
import byteSize from '../../util/byteSize';

const FileUploadUploadStatus = ({ uploadStatus }) => {
  return (
    <Table
      columns={[
        { header: 'File name', accessor: 'name' },
        {
          header: 'Size',
          accessor: 'size',
          cell: size => byteSize(size),
        },
        {
          header: 'Status',
          accessor: 'status',
        },
      ]}
      keyField="name"
      data={Object.values(uploadStatus)}
    />
  );
};

export default FileUploadUploadStatus;
